var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCautionRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.819948 12.9997H13.1733C13.6866 12.9997 14.0066 12.4464 13.7533 11.9997L7.57328 1.33305C7.31328 0.88638 6.67328 0.88638 6.41995 1.33305L0.239948 11.9997C-0.013385 12.4464 0.306615 12.9997 0.819948 12.9997ZM7.66662 10.9997H6.33328V9.66638H7.66662V10.9997ZM6.99995 8.33305C6.63328 8.33305 6.33328 8.03305 6.33328 7.66638V6.33305C6.33328 5.96638 6.63328 5.66638 6.99995 5.66638C7.36662 5.66638 7.66662 5.96638 7.66662 6.33305V7.66638C7.66662 8.03305 7.36662 8.33305 6.99995 8.33305Z",
    fill: "#E65C64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionRed);
export default __webpack_public_path__ + "static/media/caution-red.addc92375319c46d3c229e93932ff625.svg";
export { ForwardRef as ReactComponent };